import CurrenciesIcon from '@percent/cause-dashboard/assets/images/money-umbrella.webp'
import { Box, Flex, Heading, Icon, Text } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import styles from './AccountBenefitsPanel.module.scss'

const BENEFITS = ['benefit1', 'benefit2', 'benefit3'] as const

const PARTNER_TOOLS = [
  { name: 'Microsoft', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Microsoft.png') },
  { name: 'Google', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Google.png') },
  { name: 'Canva', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Canva.png') },
  { name: 'Adobe', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Adobe.png') },
  { name: 'OpenAI', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Openai.png') },
  { name: 'Atlassian', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Atlassian.png') },
  { name: 'Asana', logo: require('@percent/cause-dashboard/common/assets/images/partner-offers/Asana.png') }
]

export function AccountBenefitsPanel() {
  const { t } = useTranslation()

  return (
    <Box className={styles.panel}>
      <Heading level="h1" className={styles.heading}>
        {t('typography.oneStepSignUp.Goodstack.reverification.title')}
      </Heading>
      <Flex direction="column" gap={24}>
        <Box className={styles.card}>
          <Heading level="h2" className={styles.cardTitle}>
            {t('typography.oneStepSignUp.Goodstack.reverification.toolsTitle')}
          </Heading>
          <Text className={`${styles.bodyText} ${styles.subtitle}`}>
            {t('typography.oneStepSignUp.Goodstack.reverification.toolsSubtitle')}
          </Text>
          <ul className={styles.logoRow}>
            {PARTNER_TOOLS.map(({ name, logo }) => (
              <li key={name} className={styles.logoTile}>
                <img src={logo} alt={name} />
              </li>
            ))}
          </ul>
        </Box>
        <Box className={`${styles.card} ${styles.benefitsCard}`}>
          <Box>
            <Heading level="h2" className={styles.cardTitle}>
              {t('typography.oneStepSignUp.Goodstack.reverification.benefitsTitle')}
            </Heading>
            <ul className={styles.benefitsList}>
              {BENEFITS.map(benefit => (
                <li key={benefit} className={styles.benefitItem}>
                  <span aria-hidden className={styles.benefitIcon}>
                    <Icon name="add" size={4} color="primary400" />
                  </span>
                  <Text className={styles.bodyText}>
                    {t(`typography.oneStepSignUp.Goodstack.reverification.${benefit}`)}
                  </Text>
                </li>
              ))}
            </ul>
          </Box>
          <img className={styles.illustration} src={CurrenciesIcon} alt="" />
        </Box>
      </Flex>
    </Box>
  )
}
